export default __webpack_public_path__ + "static/media/cliente08_color.329f4a0f.png";